import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import TopNav from 'components/TopNav';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import { ACCESS_PAGE_LINK_STICKY_CONTENT_TYPE, DEFINED_TYPE_LINKS, SEARCH_JOB_FILTER, SEARCH_TYPE } from '../../config/constants';
import styles from './styles.module.scss';
import { useQuery, useQueryClient } from 'react-query';
import * as searchApi from 'api/search';
import FormDialogJob from './../../components/Jobs/FormDialogJob';
import { MuiThemeProvider } from '@material-ui/core';
import { Col, Row } from 'antd';
import { getAllTagJobs } from '../../api/tag';
import { getLocalStorage, removeLocalStorage, setLocalStorage } from '../../utils/utils';
import BottomNav from '../../components/BottomNav';
import { getAllStateForJob } from '../../api/itemJobResources';
import { getTextWebPages } from '../../api/textWebPage';
import { getAllItemJobResource } from 'api/itemJobResources';
import RenderSearchBoxElement from '../../components/Jobs/IconItemJob/RenderSearchBoxElement';
import { customThemeTableSearch } from '../../themeMui/customer-table-search';


const styleWrapInline = {
  display: 'inline-block',
};

const styleWrap = {
  fontSize: '95%',
  fontColor: 'var(--emperor)',
  fontFamily: '"Times New Roman", Times, serif, ヒラギノ角ゴ ProN',
};

const payloadFilter = {
  state: null,
  area: null,
  jobTags: [],
  items: {},
  itemRange: {},
}

const payloadFilterText = {
  area: null,
}

function SearchJob(props) {
  const history = useHistory();
  const queryClient = useQueryClient();
  const stickyContent = props?.textWebPage || '';

  const [valueObj, setValueObj] = useState(payloadFilter);
  const [valueTextObj, setTextValueObj] = useState(payloadFilterText);

  const [resourceTagJobs, setResourceTagJobs] = useState([]);
  const [listStateJobs, setListStateJobs] = useState([]);
  const [minimumSalary, setMinimumSalary] = useState();
  const [title, setTitle] = useState();
  const resultAllTagJobs = useQuery('getAllTagJobs', getAllTagJobs, { cacheTime: Infinity });
  const { data: listStateJob } = useQuery('listStateJob', getAllStateForJob, { cacheTime: Infinity });
  const { data: itemJobResources } = useQuery(['itemJobResource'], () => getAllItemJobResource(), { cacheTime: Infinity });


  useEffect(() => {
    setResourceTagJobs((resultAllTagJobs?.data?.data ?? []));
    setListStateJobs((listStateJob?.data ?? []));
  }, [resultAllTagJobs, listStateJob]);

  // useEffect(() => {
  //   let tempStickyContent = '';
  //   if (!textWebPages || !textWebPages?.data || !Array.isArray(textWebPages?.data) || !textWebPages?.data.length) {
  //     return;
  //   }
  //   const findBlogMyEdit = textWebPages?.data?.find(ele => ele.link === DEFINED_TYPE_LINKS.SEARCH_JOB && ACCESS_PAGE_LINK_STICKY_CONTENT_TYPE.includes(DEFINED_TYPE_LINKS.SEARCH_JOB));
  //   if (findBlogMyEdit) {
  //     tempStickyContent = findBlogMyEdit.content;
  //   }
  //   setStickyContent(tempStickyContent);
  // }, [textWebPages]);

  useEffect(() => {
    const fetchLocalStorage = async () => {
      const dataRaw = await getLocalStorage(SEARCH_JOB_FILTER);
      if (dataRaw) {
        try {
          const data = JSON.parse(dataRaw);
          if (data) {
            setValueObj(Object.assign({}, {
              ...payloadFilter,
              ...data,
              ...data?.stateId && { state: data.stateId },
              ...data?.areaId && { area: data.areaId },
            }));

            if (data?.minimumSalary) {
              setMinimumSalary(data.minimumSalary)
            }

            if (data?.title) {
              setTitle(data.title)
            }
          }
        } catch (e) {
          // Todo
        }
      }
    };

    fetchLocalStorage();
  }, []);

  const handleClearSearch = async () => {
    setValueObj(payloadFilter);
    setTextValueObj(payloadFilterText);
    setTitle("");
    setMinimumSalary('');
    await removeLocalStorage(SEARCH_JOB_FILTER)
  };

  const handleSearchJob = async () => {
    if (valueObj?.items) {
      for (let key in valueObj?.items) {
        if (Array.isArray(valueObj?.items[key])) {
          if (!valueObj?.items[key].length) {
            delete valueObj?.items[key];
          }
        }
      }
    }
    const data = {
      ...valueObj?.items && Object.keys(valueObj?.items).length && { items: valueObj.items },
      ...valueObj?.itemRange && Object.keys(valueObj?.itemRange).length && { itemRange: valueObj.itemRange },
      ...valueObj?.jobTags && valueObj?.jobTags.length && { jobTags: valueObj.jobTags },
      ...valueObj?.state && valueObj?.state.length && { stateId: valueObj.state },
      ...valueObj?.area && valueObj?.area.length && { areaId: valueObj.area },
      ...minimumSalary && {minimumSalary},
      ...title && {title},
    };
    await setLocalStorage(SEARCH_JOB_FILTER, JSON.stringify(data));

    try {
      const { data: userSearchList, message, messageErr } = await searchApi.searchJob(data);
      // Set data to query data after fetch api
      queryClient.setQueryData('jobSearchJobList', userSearchList);
      queryClient.setQueryData('jobSearchJobListMessage', message);
      queryClient.setQueryData('jobSearchJobListMessageErr', messageErr);

      history.push({ pathname: `${process.env.RAZZLE_PUBLIC_URL}/search-job-result` });
    } catch (e) {
      console.error(e.response?.data?.message);
    }
  };

  const onchangeData = (data, name, k) => {
    if (name === 'jobTags'
      || name === 'state'
      || name === 'area'
    ) {
      setValueObj({ ...valueObj, [name]: data });
      setTextValueObj({ ...valueTextObj, [name]: k });

      if (name === 'state') {
        // Remove data area when state change
        setValueObj({ ...valueObj, [name]: data, area: null });
        setTextValueObj({ ...valueTextObj, [name]: k, area: null });
      }
    }
  };

  const showValueTexts = (key = '') => {
    let dataKeys = valueObj[key] ?? [];

    return resourceTagJobs.filter((item) => dataKeys.includes(item.id))
      .map(ele => `<span class="d-symbol-search">${ele.label}</span>`)
      .join('');
  };

  const showValueText = (key = '') => {
    let dataKey = valueObj[key] ?? {};

    if (key === 'state') {
      return listStateJobs?.filter((state) => !! state?.label).find((item) => item.id === dataKey)?.label;
    }

    if (key === 'area') {
      return typeof valueTextObj?.area === 'object' && valueTextObj?.area !== null
        ? Object.values(valueTextObj?.area).join('')
        // ? Object.values(valueTextObj?.area).map(ele => `<span class="d-symbol-search">${ele}</span>`).join('')
        : valueTextObj?.area;
    }

    return '';
  };

  const onchangeDataItems = (data, name, k) => {
    if (name) {
      setValueObj({ ...valueObj, items: { ...valueObj.items, [name]: data } });
    }
  };

  const onchangeDataItemRange = (data, name, k) => {
    if (name) {
      setValueObj({ ...valueObj, itemRange: { ...valueObj.itemRange, [name]: data } });
    }
  };

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <MuiThemeProvider theme={customThemeTableSearch}>
        <div className={styles.searchScreen}>
          <div>
            <div>
              <div className={styles.topNavContainer}>
                <TopNav name={'仕事検索'} hasLogo={true} hasHamburger={true} />
              </div>
              <div className={`${styles.listSelect} d-search-box d-search-job-wrapper`}>
                {stickyContent && (
                  <div className="d-wrapper-header-section d-wrapper-header-padding"
                       style={{ width: 'calc(100% + 20px)', marginLeft: '-10px' }}>
                    <div className={'d-info-text font-3'}
                         dangerouslySetInnerHTML={{ __html: stickyContent }}></div>
                  </div>
                )}

                <Row
                  className={`${!!(stickyContent && stickyContent.length) ? 'd-sticky-content-has' : 'd-sticky-content-none'}`}>
                  <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                    <div>
                      <ListItem className={`d-ant-col font-2`} style={{  padding: '4px 0 0px 0' }}>
                        <span style={styleWrap} className="font-2">キーワード検索/Search Words</span>
                      </ListItem>
                      <ListItem className={'d-ant-col'} style={{ padding: "0 0 4px 0" }}>
                        <div className="d-item-box-search d-flex justify-content-center align-items-center">
                          <div className="d-range-left" style={{ width: '100%', position: 'relative' }}>
                            <input
                              name="title"
                              type="text"
                              style={{ width:'100%', minHeight: 32 }}
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                              className={styles.inputSalary}
                              min={0}
                              placeholder='お好きなテキストを入力して下さい（例：日払い）'
                            />
                          </div>
                        </div>
                      </ListItem>
                  </div>
                  </Col>
                  <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                    <span style={styleWrap} className="font-2">
                      都道府県検索/Prefecture
                    </span>
                  </Col>
                  <Col xs={12} className="d-flex justify-content-center" style={{ padding: '1px 0 4px' }}>
                    <div className="d-item-box-search">
                      <FormDialogJob
                        values={valueObj.state}
                        namelabel={'都道府県検索'}
                        nametext="state"
                        resource={listStateJobs?.filter((state) => !! state?.label)}
                        onchangeData={(e, name, k) => onchangeData(e, name, k)}
                        text={showValueText('state')}
                        multi={false}
                      />
                    </div>
                  </Col>

                  <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                    <span style={styleWrap} className="font-2">
                      エリア検索/Area
                    </span>
                  </Col>
                  <Col xs={12} className="d-flex justify-content-center" style={{ padding: '1px 0 4px' }}>
                    <div className="d-item-box-search">
                      <FormDialogJob
                        values={valueObj.area}
                        namelabel={'エリア検索'}
                        nametext="area"
                        userState={valueObj.state}
                        resource={[]}
                        onchangeData={(e, name, k) => onchangeData(e, name, k)}
                        text={showValueText('area')}
                        multi={false}
                        setTextValueObj={setTextValueObj}
                        valueTextObj={valueTextObj}
                      />
                    </div>
                  </Col>
                  <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                    <div>
                      <ListItem className={`d-ant-col font-2`} style={{  padding: '4px 0 0px 0' }}>
                        <span style={styleWrap} className="font-2">給与額/Salary</span>
                      </ListItem>
                      <ListItem className={'d-ant-col'} style={{ padding: "0 0 4px 0" }}>
                        <div className="d-item-box-search d-flex justify-content-center align-items-center">
                          <div className="d-range-left" style={{ width: '88%', position: 'relative' }}>
                            <input
                              name="minimum_salary"
                              type="number"
                              style={{ width:'100%', minHeight: 32 }}
                              value={minimumSalary}
                              onChange={(e) => setMinimumSalary(e.target.value)}
                              className={styles.inputSalary}
                              min={0}
                              placeholder='金額を入力して下さい'
                            />
                          </div>
                          <span style={{ paddingLeft: 10 }}>円以上</span>
                        </div>
                      </ListItem>
                    </div>
                  </Col>

                  <RenderSearchBoxElement itemJobResources={itemJobResources?.data ?? []}
                                          onchangeDataItems={onchangeDataItems}
                                          onchangeDataItemRange={onchangeDataItemRange}
                                          valueObj={valueObj}
                                          styles={styles}
                  />
                  <Col xs={12} style={{ padding: '4px 0 0 0' }}>
                  <span style={styleWrap} className="font-2">
                    仕事タグ/#Hashtag
                  </span>
                  </Col>
                  <Col xs={12} style={{ display: 'flex', justifyContent: 'center', padding: '1px 0 4px' }}>
                    <div style={(styleWrapInline, {
                      position: 'relative',
                      width: '100%',
                      marginRight: '18px',
                      marginLeft: '18px',
                    })}>
                      <FormDialogJob
                        values={valueObj?.jobTags}
                        namelabel={'仕事タグ'}
                        nametext="jobTags"
                        multi={true}
                        resource={resourceTagJobs}
                        onchangeData={(e, name, k) => onchangeData(e, name, k)}
                        text={showValueTexts('jobTags')}
                      />
                    </div>
                  </Col>
                </Row>

                <List>
                  <ListItem alignItems="flex-start" style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        position: 'fixed',
                        bottom: 56,
                        margin: 'auto',
                        width: '100%',
                        padding: '8px 0',
                        maxWidth: '560px',
                      }}
                    >
                      <Button className="btn btn-main" variant="contained" onClick={handleSearchJob}>
                        <span>検索する</span>
                      </Button>
                      <Button className="btn btn-sub" variant="contained" onClick={handleClearSearch}>
                        <span>クリア</span>
                      </Button>
                    </div>
                  </ListItem>
                </List>
              </div>

              <BottomNav />
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    </div>
  );
}

SearchJob.getInitialProps = async ({
                                       req, res, match, history, location, ...ctx
                                     }) => {
  let textWebPages = [];
  try {
    let result = await getTextWebPages();
    textWebPages = result?.data || [];
  } catch (e) {
    textWebPages = [];
  }

  const findBlogMyEdit = textWebPages?.data?.find(ele => ele.link === DEFINED_TYPE_LINKS.SEARCH_JOB && ACCESS_PAGE_LINK_STICKY_CONTENT_TYPE.includes(DEFINED_TYPE_LINKS.SEARCH_JOB));

  return { textWebPage: findBlogMyEdit?.content || '' };
};

export default SearchJob;
